import { SHIPPING_COUNTRY_CODES } from "@/data/shipping-country-code"
import { CENTRA_LANGUAGE_CODE } from "@/data/supported-languages"

export const FREE_SHIPPING_VOUCHER_CODE = "free-shipping-for-poc-members"
export const DEFAULT_USER_COUNTRY_CODE = SHIPPING_COUNTRY_CODES.Germany // used in middleware and where we use next headers country code
export const siteUrl = process.env.NEXT_PUBLIC_SITEMAP_DOMAIN || "https://localhost:3000"
export const UNIVERSAL_DEFAULT_LANGUAGE =
    process.env.FALLBACK_DEFAULT_LANGUAGE ?? CENTRA_LANGUAGE_CODE.En
export const EXCLUDE_ABSOLUTE_PATH_GENERATION_FOR_SITE_SELECTOR_LINKS = [
    "cart",
    "checkout",
    "payment-failed",
    "payment-result"
]
